import { navigate } from 'gatsby'
import React, { FC } from 'react'

import { RewardsQuery } from '../../../../../../../graphql/search'
import { monthName, parseRewardsPeriod } from '../../../../../../../lib/rewards/periods'
import { zeroMoney } from '../../../../../../../lib/rewards/snapshots'
import { RewardsCardHeader } from '../../../RewardsCard'
import { RewardsLink } from '../../../RewardsLink'
import { SalesClassificationCard } from '../SalesClassificationCard'
import * as Styled from './styled'

export interface SalesOverviewGeneralProps {
  currentSnapshot?: NonNullable<
    NonNullable<RewardsQuery['customer']>['rewardsSnapshots']
  >['nodes'][number]
}

export const SalesOverviewGeneral: FC<SalesOverviewGeneralProps> = ({ currentSnapshot }) => {
  const period = currentSnapshot?.period ? parseRewardsPeriod(currentSnapshot.period) : null
  const month = period?.month ? monthName(period.month) : null
  const sales = currentSnapshot?.sales
  return (
    <div>
      <RewardsCardHeader>
        <Styled.Heading2>Qualifying Sales{month ? ` for ${month}` : ''}</Styled.Heading2>
        <Styled.HeaderActions>
          <Styled.HeaderParagraph>Month-to-date</Styled.HeaderParagraph>
          <RewardsLink to="/account/orders">View All Orders</RewardsLink>
        </Styled.HeaderActions>
      </RewardsCardHeader>
      <Styled.ClassificationsContainer>
        <SalesClassificationCard
          name="Qualifying Sales"
          value={sales?.total ?? zeroMoney()}
          onClick={() => null}
        />
        <SalesClassificationCard
          name="Wholesale"
          value={sales?.wholesale ?? zeroMoney()}
          onClick={() => navigate('/account/rewards/orders/in-practice')}
        />
        <SalesClassificationCard
          name="Retail"
          value={sales?.retail ?? zeroMoney()}
          onClick={() => navigate('/account/rewards/orders/dispensary')}
        />
      </Styled.ClassificationsContainer>
    </div>
  )
}
